import {
  type PerspectiveSublevelPortfolio,
  type RawPerspectiveSublevelPortfolio,
} from '@/lib/types';
import { createContext } from 'react';
import { type Updater } from 'use-immer';

const PerspectiveSublevelPortfolioContext = createContext<
  [PerspectiveSublevelPortfolio, Updater<RawPerspectiveSublevelPortfolio>]
>([new Map(), () => {}]);

export default PerspectiveSublevelPortfolioContext;
